module.exports = __webpack_public_path__ + "media/images/flags/hu-1ae32f74e4c536e74d35101c4c7ff997.svg";